import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    flex: 1,
    marginTop: 20
  }
});
